import React from "react";
import "./App.css";
import WyndRouter from "./WyndRouter";

function App() {
  return (
    <div className="App">
      <WyndRouter />
    </div>
  );
}

export default App;
